import axios from 'axios';

export default async function (form_name, payload) {
    return await axios.post(process.env.VUE_APP_FORMS_ENDPOINT + `/process-form?id=${form_name}`, payload, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
